import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { CoreValuesContainer, CoreValuesIconography, CoreValuesIconographyEntry, CoreValuesProcessImage, CoreValuesTitle } from './coreValues.styles';

interface CoreValuesProps {
  sectionTitle: string;
  sectionSubtitle: string;
  coreValuesTitle: string;
  coreValuesList: {
    name: string;
    image: IGatsbyImageData
  }[]
}

const CoreValues = ({ sectionTitle, sectionSubtitle, coreValuesTitle, coreValuesList }: CoreValuesProps): JSX.Element => {
  return (
    <CoreValuesContainer>
      <CoreValuesTitle>
        <FadeInAnimationWrapper>
          <Heading
            text={sectionTitle}
            size="2.5em"
            sizeMd="1.5em"
            align="center"
          />
        </FadeInAnimationWrapper>
        <FadeInAnimationWrapper>
          <Paragraph
            text={sectionSubtitle}
            size="1.5em"
            sizeMd="1.2em"
            align="center"
            weight="light"
          />
        </FadeInAnimationWrapper>
      </CoreValuesTitle>
      <CoreValuesTitle>
        <FadeInAnimationWrapper>
          <Heading
            text={coreValuesTitle}
            size="2.5em"
            sizeMd="1.5em"
            align="center"
          />
        </FadeInAnimationWrapper>
        <CoreValuesIconography>
          {
            coreValuesList.map((coreValue, index) => (
              <FadeInAnimationWrapper key={index}>
                <CoreValuesIconographyEntry>
                  <CoreValuesProcessImage>
                    <Image childImageSharp={coreValue.image} alt={coreValue.name} />
                  </CoreValuesProcessImage>
                  <Heading
                    text={coreValue.name}
                    size="1.35em"
                    sizeMd="1em"
                    align="center"
                    weight="normal"
                  />
                </CoreValuesIconographyEntry>
              </FadeInAnimationWrapper>
            ))
          }
        </CoreValuesIconography>
      </CoreValuesTitle>
    </CoreValuesContainer>
  )
}

export default CoreValues;
